import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'
import LoginView from '@/views/Login.view.vue'
import PanelView from '@/views/Panel.view.vue'
import SymposiaDetailView from '@/views/SymposiaDetail.view.vue'
import InscriptionDetailView from '@/views/InscriptionDetail.view.vue'
import NewInscriptionView from '@/views/NewInscription.view.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: PanelView
  },
  {
    path: '/login',
    name: 'LoginView',
    component: LoginView
  },
  {
    path: '/panel',
    name: 'Panel',
    component: PanelView
  },
  {
    path: '/apply/:acronym/',
    name: 'Apply',
    component: NewInscriptionView
  }, {
    path: '/symposiaDetail/:symposiaId/',
    name: 'SymposiaDetail',
    component: SymposiaDetailView,

  }, {
    path: '/inscriptionDetail/:simposioId/:inscriptionId',
    name: 'InscriptionDetail',
    component: InscriptionDetailView
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach(async (to, from, next) => {
  if (to.name == 'LoginView' || to.name == 'Apply') {
    next()
  } else {
    if (store.state.user) {
      next()
    } else {
      await new Promise(resolve => setTimeout(resolve, 1000));
      if (store.state.user) { next() } else {
        console.log('Acceso denegado');
      }
    }
  }
})
/*
router.beforeEach((to, from, next) => {
 console.log('nepe');
if (store.state.user) {
 console.log('nepe1');
 next()
 console.log('nepe2');

} else {
 console.log('nepe3');

 if (to.name == 'LoginView' || to.name == 'Apply') {
   console.log('nepe4');
   next()
 } else {
   console.log('nepe5');
   router.push("Apply")
 }
}

})
*/

export default router
